var map = {
	"./alert_buy.svg": "63da",
	"./alert_check.svg": "c375",
	"./alert_copy.svg": "588e",
	"./alert_danger.svg": "2f33",
	"./alert_deposit.svg": "a94f",
	"./alert_ref.svg": "aa91",
	"./alert_swap.svg": "7e4b",
	"./alert_trade.svg": "34f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79a1";